module.exports = __webpack_public_path__ + "static/media/Diameter.75ff454e.jpg";